import { notificationPreferenceAction } from "../actions/notificationPreferenceAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showList: false,
  account: {},
  selectedAccount: "",
  editPreference: false,
  toggleAccount: false,
};

const notificationPreferenceSlice = createSlice({
  name: "notificationPreference",
  initialState: initialState,
  reducers: notificationPreferenceAction,
});

export const { showPreferenceList, toggleEditPreference, toggleAccountFilter } =
  notificationPreferenceSlice.actions;

export default notificationPreferenceSlice.reducer;
